// Base interface with common audit fields
export interface AuditFields {
  createdBy?: string | null;
  createdTs?: string | null;
  updatedBy?: string | null;
  updatedTs?: string | null;
}

export interface TestSuiteInfo {
  id: string;
  name?: string | null;
  description?: string | null;
  isScheduled: boolean;
}

export interface UpdateTestSuiteScheduleRequest {
  testSuiteId: string;
  isScheduled: boolean;
}

export interface ToolVersionRevisionInfo {
  version: string;
  revision: number;
  status?: string | null;
}

export interface TestExecutionScope {
  phase: string;
  clientLLMType: string;
  enabledTools: string[];
  toolVersionRevision: Record<string, ToolVersionRevisionInfo>;
}

export interface TestExecutionRequest {
  testSuiteId: string;
  executionScope: TestExecutionScope;
}

export enum LLMType {
  ASKRINO_VANILLA = 'ASKRINO_VANILLA',
  ASKRINO_AGENTIC = 'ASKRINO_AGENTIC'
}

export enum Phase {
  TEST = 'test',
  BETA = 'beta',
  LIVE = 'live'
}

// Test Suite Content Structure
export interface TestStep {
  question: string;
  expectedTools?: string[];
}

export interface TestCase extends AuditFields {
  id: number;
  name: string;
  tags: string[];
  isActive: boolean;
  description: string;
  testSteps: TestStep[];
}

export interface TestSuiteContent extends TestSuiteInfo, AuditFields {
  description: string;
  prompt?: string | null;
  iterations: number;
  isActive: boolean;
  testCases: TestCase[];
}

// Version-related interfaces
export interface TestSuiteVersionInfo {
  versionId: string;
  lastModified: string;
  isLatest: boolean;
}

export interface TestSuiteDetail {
  latestContent: TestSuiteContent;
  versions: TestSuiteVersionInfo[];
}

export interface TestSuiteVersion {
  versionId: string;
  lastModified: string;
  isLatest: boolean;
  content: TestSuiteContent;
}
